import * as React from 'react';
import useWindowSize from 'hooks/useWindowSize';

const FaceBackground = ({
    fill = '#878B87',
    width = '546',
    height = '545',
    ...attributes
}: React.SVGProps<SVGSVGElement>) => {
    const windowSize = useWindowSize()

    return (windowSize.width > 950 ?
        <svg width={width} height={height} {...attributes} viewBox="0 0 1000 1000" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path opacity="0.5" fillRule="evenodd" clipRule="evenodd" d="M1000 0H0V1000H1000V0ZM360 501.04C360 593.548 420.089 697 500.5 697V696.997C580.913 696.997 641 593.538 641 501.037V443.5C641 366.03 577.973 303 500.5 303C423.027 303 360 366.029 360 443.5V501.04Z" fill="black"/>
        </svg>
        : <svg width="1000" height="1000" {...attributes} viewBox="0 0 1000 1000" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path opacity="0.5" fillRule="evenodd" clipRule="evenodd" d="M1000 0H0V1000H1000V0ZM360 501.04C360 593.548 420.086 697 500.493 697V696.997C580.902 696.997 640.986 593.538 640.986 501.037V443.5C640.986 366.03 577.962 303 500.493 303C423.024 303 360 366.029 360 443.5V501.04Z" fill="black" />
        </svg>
    )
};

export default FaceBackground;
